module.exports = __webpack_public_path__ + "static/media/1.23da6068.jpg";